window._ = require("lodash");
window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

jQuery(function () {
    $("#sidebarCollapse").on("click", function () {
        $("#sidebar").toggleClass("toggleSidebar");
    });
});
